meedy.factory('meedy.invoiceService', ['$q', '$translate', '$http', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, $http, baseService, objectHelper, config) {

        function InvoiceService() {

            this.getInvoices = function (criteria) {
                var d = $q.defer();

                var _criteria = objectHelper.convertDatesToTimes(criteria);
                baseService.post(config.API_URL + '/invoices/getInvoices', _criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, MedicalPostInvoiceMeedyVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getWpInvoices = function (criteria) {
                var d = $q.defer();
                var _criteria = objectHelper.convertDatesToTimes(criteria);
                baseService.post(config.API_URL + '/wpInvoices/getInvoices', _criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, MedicalPostWpInvoiceMeedyVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getDownloadToken = function (idInvoice, fileType) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/wpInvoices/getDownloadToken/' + idInvoice, fileType).then(
                    function (token) {
                        d.resolve(token);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getInvoicesWaitingForAcceptation = function () {
                var d = $q.defer();

                baseService.post(config.API_URL + '/invoices/getInvoicesWaitingForAcceptation/').then(
                    function (token) {
                        d.resolve(token);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.updateInvoice = function (invoice) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/invoices/updateInvoice', invoice).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, MedicalPostInvoiceMeedyVO);
                        d.resolve(data);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.download = function (token, fileType) {
                
				return baseService.get(config.API_URL + '/wpInvoices/download/' + token, {responseType: 'blob'}).then(
					function(successResponse) {
						return successResponse;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
				
            };

        }

        return new InvoiceService();
    }
]);
